import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { KibButtonNew } from '@chewy/kib-controls-react'
import { KibMoreHorizIcon } from '@chewy/kib-icons-react'

import type { Conversation } from '~/types'

import CommunicationsHeaderMenu from './CommunicationsHeaderMenu'

import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css'

interface CommunicationsHeaderMenuButtonProps {
  conversation: Conversation
}

const CommunicationsHeaderMenuButton = ({
  conversation,
}: CommunicationsHeaderMenuButtonProps) => {
  const { t } = useTranslation('Common')
  const buttonRef = useRef<HTMLButtonElement>(null)

  return (
    <>
      <KibButtonNew
        iconOnly
        aria-label={t('ACTIONS_MENU')}
        emphasis="tertiary"
        icon={<KibMoreHorizIcon />}
        ref={buttonRef}
        theme="utility"
      />
      <CommunicationsHeaderMenu
        conversation={conversation}
        triggerRef={buttonRef}
      />
    </>
  )
}

export default CommunicationsHeaderMenuButton
